import React from "react";
import { Helmet } from "react-helmet";
import "./aboutus.scss";
import "../brandlogos/brandLogos.scss";

const AboutUs = () => {
  const logos = [
    { id: 1, src: "brand1.png", alt: "Company 1" },
    { id: 2, src: "brand2.png", alt: "Company 2" },
    { id: 3, src: "brand3.png", alt: "Company 3" },
    { id: 4, src: "brand4.png", alt: "Company 4" },
    { id: 5, src: "brand5.png", alt: "Company 5" },
    { id: 6, src: "brand6.png", alt: "Company 6" },
    { id: 7, src: "brand7.png", alt: "Company 7" },
    { id: 8, src: "brand8.png", alt: "Company 8" },
  ];

  const quoteCards = [
    {
      image: "/anup.jpg",
      quote: "Driven by a passion for emerging technologies and a deep curiosity about the universe beyond.",
    },
    {
      image: "/team1.jpg",
      quote: "Challenges may come and go, but resilience defines those who rise.",
    },
    {
      image: "/team2.jpg",
      quote: "Blending experience with creativity to deliver a distinctive edge to every project.",
    },
    {
      image: "/team3.jpg",
      quote: "A creative spirit with a love for innovation, travel, and all things football—Hala Madrid!",
    },
    {
      image: "/team4.jpg",
      quote: "Language lover, detail perfectionist, and always seeking the next big idea.",
    },
    {
      image: "/team5.png",
      quote: "Digitally inspired, style-forward, and never says no to a good Bubble Tea.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>About Us | Arrow Digital - Digital Marketing Experts</title>
        <meta
          name="description"
          content="Discover Arrow Digital’s journey since 2007. A Melbourne-based full-service digital marketing agency delivering results with innovation, experience, and creativity."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://arrowdigitalmarketing.com/about-us" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="About Us | Arrow Digital" />
        <meta
          property="og:description"
          content="Meet the passionate team behind Arrow Digital. 15+ years of experience delivering award-winning digital marketing strategies."
        />
        <meta property="og:url" content="https://arrowdigitalmarketing.com/about-us" />
        <meta property="og:image" content="https://arrowdigitalmarketing.com/about-cover.jpg" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | Arrow Digital" />
        <meta
          name="twitter:description"
          content="Meet the passionate minds behind Arrow Digital’s success in digital marketing since 2007."
        />
        <meta name="twitter:image" content="https://arrowdigitalmarketing.com/about-cover.jpg" />
      </Helmet>

      <div className="about-us">
        {/* Banner Section */}
        <div
          style={{
            backgroundImage: "url(/about.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="banner-section"
        >
          <h1>About Us</h1>
          <p>Innovating the future, together.</p>
        </div>

        {/* Intro Section */}
        <div className="intro-section">
          <p>
            Arrow Digital was established in 2007 by two visionary digital marketers who recognized the immense potential of digital marketing in shaping global brands. Driven by their passion for technology, innovation, and all things digital, they have accumulated years of expertise—constantly learning, experimenting, and refining strategies to achieve success.
          </p>
        </div>

        {/* Our Mission Section */}
        <div className="mission-section">
          <h2>The Company</h2>
          <p>
            Based in Melbourne, Arrow Digital is an award-winning, full-service digital marketing agency with over 15 years of success in delivering impactful campaigns for long-term clients. Backed by a skilled team of strategic marketers and digital specialists, we leverage integrated marketing expertise to drive growth, enhance engagement, maximize ROI, and strengthen our clients' market presence.
          </p>
        </div>

        {/* Team Section */}
        <div className="team-section">
          <h2>Meet the Team</h2>
          {/* Optionally add team cards here */}
        </div>

        {/* Quote Section */}
        <div className="quote-section">
          <h2>Words That Inspire Us</h2>
          <div className="quote-grid">
            {quoteCards.map((item, index) => (
              <div className="quote-card" key={index}>
                <img src={item.image} alt="person" className="quote-avatar" />
                <p className="quote-text">"{item.quote}"</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Client Logos */}
      <div className="brand-logos">
        <div className="container">
          <h2 className="brand-logos__title">Our Clients</h2>
          <div className="brand-logos__grid">
            {logos.map((logo) => (
              <div key={logo.id} className="brand-logos__item">
                <img src={logo.src} alt={logo.alt} className="brand-logos__image" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
